@if (contentVisible$ | async) {
    <pace-forms-accordion [group]="group$ | async" [open]="open" [id]="groupId$ | async">
        <ng-template #heading>
            <div class="g-0 row align-items-center">
                <span class="col-auto content-icon {{ answers$ | async | statusIcon }}"></span>
                <span class="col" [innerHTML]="headingText$ | async"></span>
            </div>
        </ng-template>
        @if (enableIndividualization$ | async) {
            <ng-template #actionButton>
                <ul class="navbar-nav mx-lg-3">
                    @if ((visibilityButton$ | async) === true && (isTopicIndividualizable$ | async)) {
                        <li class="nav-item">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                (click)="updateTopicVisibility(false)"
                                [tooltip]="'TOOLTIP_TOPIC_VISIBLE' | translate"
                                aria-label="'TOOLTIP_TOPIC_VISIBLE' | translate"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faEye"></fa-icon>
                            </button>
                        </li>
                    }
                    @if ((visibilityButton$ | async) === false && (isTopicIndividualizable$ | async)) {
                        <li class="nav-item">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                (click)="updateTopicVisibility(true)"
                                [tooltip]="'TOOLTIP_TOPIC_HIDDEN' | translate"
                                aria-label="'TOOLTIP_TOPIC_HIDDEN' | translate"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faEyeSlash"></fa-icon>
                            </button>
                        </li>
                    }
                </ul>
            </ng-template>
        }
        @if (open) {
            <ng-template #body>
                <div *ngrxLet="heading$; let heading">
                    @if ((readOnly$ | async) === false && (autofillCheckpoints$ | async)?.length > 1) {
                        <form class="form-inline mb-3">
                            <div class="mb-3">
                                <label
                                    [attr.for]="heading.chapterNumber"
                                    class="col-form-label me-2"
                                    translate="F4M_CONTENT_RENDER_AUTOFILL_CHECKPOINT_LABEL"
                                ></label>
                                <pace-forms-dropdown
                                    *ngrxLet="radioButtonLabels$; let radioButtonLabels"
                                    [id]="heading.chapterNumber"
                                >
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onAstoriaAutofillClick(radioOptionsTypes.YES)"
                                            >{{ radioButtonLabels.yes }}</a
                                        >
                                    </li>
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onAstoriaAutofillClick(radioOptionsTypes.NO)"
                                            >{{ radioButtonLabels.no }}</a
                                        >
                                    </li>
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onAstoriaAutofillClick(radioOptionsTypes.NA)"
                                            >{{ radioButtonLabels.na }}</a
                                        >
                                    </li>
                                </pace-forms-dropdown>
                            </div>
                        </form>
                    }
                    @if ((readOnly$ | async) === false && (autofillFunctionalElements$ | async)?.length > 1) {
                        <form class="form-inline mb-3">
                            <div class="mb-3">
                                <label
                                    [attr.for]="heading.chapterNumber"
                                    class="col-form-label me-2"
                                    translate="F4M_CONTENT_RENDER_AUTOFILL_CHECKPOINT_LABEL"
                                ></label>
                                <pace-forms-dropdown
                                    *ngrxLet="radioButtonLabels$; let radioButtonLabels"
                                    [id]="heading.chapterNumber"
                                >
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onCosimaAutofillClick(choicesTypes.CHOICE_POSITIVE)"
                                            >{{ radioButtonLabels.yes }}</a
                                        >
                                    </li>
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onCosimaAutofillClick(choicesTypes.CHOICE_NEGATIVE)"
                                            >{{ radioButtonLabels.no }}</a
                                        >
                                    </li>
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onCosimaAutofillClick(choicesTypes.CHOICE_NA)"
                                            >{{ radioButtonLabels.na }}</a
                                        >
                                    </li>
                                </pace-forms-dropdown>
                            </div>
                        </form>
                    }
                    @for (child of children$ | async; track trackByFn($index, child)) {
                        @if (child.type === contentType.CHECKPOINT) {
                            <pace-checkpoint [checkpoint]="child.id" [parentForm]="parentForm"></pace-checkpoint>
                        }
                        @if (child.type === contentType.FUNCTIONAL) {
                            <pace-functional-element
                                [id]="child.id"
                                [parentForm]="parentForm"
                            ></pace-functional-element>
                        }
                        @if (child.type === contentType.CONTENT) {
                            <pace-content-renderer
                                [contentId]="child.id"
                                [parentForm]="parentForm"
                            ></pace-content-renderer>
                        }
                    }
                </div>
            </ng-template>
        }
        <ng-template #closer>
            <div role="link" [innerHTML]="closer$ | async"></div>
        </ng-template>
    </pace-forms-accordion>
}
